export default __webpack_public_path__ + "static/Flight-Hero-Fixed-31234913b27a780e7e0881fb1960b72d.png";